import { useContext } from 'react'
import { AppearanceContext, type Density } from '@/shared/components/appearance-context'

export type { Density }

/** Préférence de densité (compact/default/comfy), via AppearanceProvider. */
export function useDensity() {
  const ctx = useContext(AppearanceContext)
  if (!ctx) {
    throw new Error('useDensity must be used within an AppearanceProvider')
  }
  return { density: ctx.density, setDensity: ctx.setDensity }
}
